// extracted by mini-css-extract-plugin
export default {"icon-trash":"ProductsListLoadMore_icon-trash__TR7c4"};